import TabBox from '../../../javascripts/utils/TabBox';

document.querySelectorAll('.multibox').forEach(($box) => new TabBox($box));
